import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const NAV = [
  { to: '/dashboard',          label: 'Dashboard',       icon: '▦' },
  { to: '/seo-action-center',  label: 'Site Audit',      icon: '⊙' },
  { to: '/meta-generator',     label: 'Meta Generator',  icon: '✦' },
  { to: '/internal-links',     label: 'Internal Links',  icon: '⟶' },
  { to: '/traffic',            label: 'AI Traffic',      icon: '◈' },
];

export default function AppShell({ children }) {
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0f', display: 'flex', fontFamily: "'Inter', system-ui, -apple-system, sans-serif" }}>
      {/* Sidebar */}
      <aside style={{
        width: collapsed ? 56 : 220,
        background: '#0f0f17',
        borderRight: '1px solid rgba(255,255,255,0.06)',
        display: 'flex', flexDirection: 'column',
        transition: 'width 0.2s ease',
        flexShrink: 0,
        position: 'sticky', top: 0, height: '100vh',
        overflow: 'hidden',
      }}>
        <div style={{ padding: collapsed ? '20px 0' : '20px 20px 28px', display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'space-between', minHeight: 72 }}>
          {!collapsed && (
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <span style={{ color: '#a78bfa', fontWeight: 800, fontSize: 17, letterSpacing: '-0.5px', whiteSpace: 'nowrap' }}>
                SEO<span style={{ color: '#60a5fa' }}>Dash</span>
                <span style={{ color: '#7c3aed', fontSize: 11, marginLeft: 2, fontWeight: 600 }}>360</span>
              </span>
            </Link>
          )}
          <button onClick={() => setCollapsed(c => !c)}
            style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 18, padding: 4, lineHeight: 1, flexShrink: 0 }}
            title={collapsed ? 'Expand' : 'Collapse'}>
            {collapsed ? '›' : '‹'}
          </button>
        </div>

        <nav style={{ flex: 1, padding: '0 8px' }}>
          {NAV.map(item => {
            const active = location.pathname === item.to || (item.to !== '/dashboard' && location.pathname.startsWith(item.to));
            return (
              <Link key={item.to} to={item.to} title={collapsed ? item.label : undefined} style={{
                display: 'flex', alignItems: 'center',
                gap: collapsed ? 0 : 10,
                justifyContent: collapsed ? 'center' : 'flex-start',
                padding: collapsed ? '12px 0' : '10px 12px',
                margin: '2px 0', borderRadius: 8,
                color: active ? '#e2e8f0' : '#64748b',
                background: active ? 'rgba(124,58,237,0.12)' : 'transparent',
                borderLeft: active ? '2px solid #7c3aed' : '2px solid transparent',
                textDecoration: 'none', fontSize: 13, fontWeight: 500,
                transition: 'all 0.15s',
              }}>
                <span style={{ fontSize: 14, flexShrink: 0 }}>{item.icon}</span>
                {!collapsed && <span style={{ whiteSpace: 'nowrap' }}>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div style={{
          padding: collapsed ? '16px 0' : '16px',
          borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex', flexDirection: 'column',
          alignItems: collapsed ? 'center' : 'flex-start', gap: 8,
        }}>
          {!collapsed && (
            <div style={{ fontSize: 11, color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
              {user?.email}
            </div>
          )}
          <button onClick={logout} title="Sign out"
            style={{ background: 'none', border: 'none', color: '#475569', fontSize: collapsed ? 16 : 12, cursor: 'pointer', padding: 0, fontFamily: 'inherit' }}>
            {collapsed ? '⊗' : '↪ Sign out'}
          </button>
        </div>
      </aside>

      {/* Content — transform creates containing block for any position:fixed children */}
      <main style={{ flex: 1, minWidth: 0, overflow: 'auto', minHeight: '100vh', transform: 'translateZ(0)' }}>
        {children}
      </main>
    </div>
  );
}
